import { ErroApi } from '../api';
export function agruparSegredo(segredo: string): string { return segredo.replace(/\s/g, '').match(/.{1,4}/g)?.join(' ') ?? ''; }
export function codigoMfa(valor: string): string { return valor.replace(/\D/g, '').slice(0, 6); }
export function erroMfa(erro: unknown): string {
  if (!(erro instanceof ErroApi)) return 'erro';
  const codigos: Record<string, string> = {
    mfa_codigo_invalido: 'codigoInvalido', mfa_codigo_reusado: 'codigoReusado', mfa_desafio_invalido: 'desafioInvalido',
    mfa_bloqueado: 'bloqueadoGenerico', senha_invalida: 'senhaInvalida', senha_atual_invalida: 'senhaInvalida', rede: 'rede',
  };
  return codigos[erro.code] ?? 'erro';
}
export function bloqueioMfa(erro: unknown): string | null {
  return erro instanceof ErroApi && erro.code === 'mfa_bloqueado' && typeof erro.details?.ate === 'string' ? erro.details.ate : null;
}
export function bloqueioVigente(ate: string | null, agora = Date.now()): boolean { return !!ate && Date.parse(ate) > agora; }
